import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import isAdmin from '../shared/hoc/isAdmin';
import EnginePanel from './engine/EnginePanel';
import GeometryPanel from './geometry/GeometryPanel';
import HelpPanel from './help/HelpPanel';
import MaterialPanel from './material/MaterialPanel';
import ScenarioPanel from './scenario/ScenarioPanel';

interface IBackofficeProps {}

const Backoffice = (props: IBackofficeProps) => {
    const [value, setValue] = React.useState('1');

    const { t } = useTranslation();

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label='lab API tabs example'>
                        <Tab variant='standard' label={t('geometry')} value='1' />
                        <Tab variant='standard' label={t('material')} value='2' />
                        <Tab variant='standard' label={t('scenario')} value='3' />
                        <Tab variant='standard' label={t('engineType')} value='4' />
                        <Tab variant='standard' label={t('help')} value='5' />
                    </TabList>
                </Box>
                <TabPanel value='1'>
                    <GeometryPanel />
                </TabPanel>
                <TabPanel value='2'>
                    <MaterialPanel />
                </TabPanel>
                <TabPanel value='3'>
                    <ScenarioPanel />
                </TabPanel>
                <TabPanel value='4'>
                    <EnginePanel />
                </TabPanel>
                <TabPanel value='5'>
                    <HelpPanel />
                </TabPanel>
            </TabContext>
        </Box>
    );
};

export default isAdmin(Backoffice);
